module.exports = __webpack_public_path__ + "static/media/3coach3_cropped.6a7d71d2.png";